<template>
  <div v-if="isAudit" style="overflow: auto">
    <a-card hoverable :bordered="false">
      <a-row type="flex">
        <!-- <a-col class="mr_20">
          <span>上传日期：</span>
          <a-date-picker
            v-model="start"
            @change="onStart"
            format="YYYY-MM-DD"
            placeholder="请选择开始日期"
            style="width: 150px"
          />
          -
          <a-date-picker
            v-model="end"
            @change="onEnd"
            placeholder="请选择结束日期"
            style="width: 150px"
          />
        </a-col> -->
        <!-- <a-col>
          <span>审核状态：</span>
          <a-radio-group
            style="line-height: 32px"
            class="mr_20"
            :options="plainOptions"
            :default-value="'待处理'"
            @change="onChange1"
          />
        </a-col> -->
        <!-- <a-col class="mr_20" v-if="isDeal">
          <span>评测状态：</span>
          <a-select
            allowClear
            v-model="deal_status"
            default-value=""
            style="width: 150px"
          >
          <a-select-option :value="0"> 全部 </a-select-option>
          <a-select-option :value="1"> 已评测 </a-select-option>
          <a-select-option :value="2"> 待评测 </a-select-option>
          </a-select>
        </a-col> -->
        <a-col class="flex">
          <a-input
            ref="userNameInput"
            v-model="works_name"
            placeholder="输入产品名称搜索"
          >
            <a-icon slot="prefix" type="search" />
          </a-input>
          <a-button class="ml_20" type="primary" @click="getData">
            搜索
          </a-button>
          <a-button class="ml_20" @click="resetBtn"> 重置 </a-button>
          <!-- <a-button class="ml_20" type="primary" @click="goAudits">
            批量审核
          </a-button> -->
        </a-col>
      </a-row>
    </a-card>
    <a-card
      style="margin-top: 16px; overflow: auto"
      hoverable
      :bordered="false"
    >
      <a-tabs :default-active-key="status" @change="tabChange">
        <!-- <a-tab-pane :key="" :tab="`全部${'(' + lens.total + ')'}`"></a-tab-pane> -->
        <a-tab-pane
          :key="evaluating ? 2 : 0"
          :tab="`${evaluating ? '待评测' : '待审核'}${
            '(' + (evaluating ? lens.wait_count : lens.no_finish) + ')'
          }`"
        ></a-tab-pane>
        <a-tab-pane
          :key="evaluating ? 1 : 2"
          :tab="`${evaluating ? '已评测' : '已审核'}${
            '(' + (evaluating ? lens.deal_count : lens.finish) + ')'
          }`"
          force-render
        ></a-tab-pane>
        <!-- <a-tab-pane
          :key="1"
          :tab="`已合议${'(' + lens.discussion + ')'}`"
          force-render
        ></a-tab-pane> -->
        <!--  <a-button
          style="background-color: #00c300; border-color: #00c300"
          type="primary"
          slot="tabBarExtraContent"
          @click="$router.push('/work/upload')"
        >
          上传产品
        </a-button> -->
      </a-tabs>
      <a-table
        :columns="columns"
        :data-source="data"
        :pagination="pagination"
        :scroll="{ y: tableH - 150 }"
      >
      <span slot="is_second" slot-scope="text, record">
        <span v-if="record.is_second" style="color:#5d5e5d">二次</span>
        <span v-else style="color:#12f4d2">一次</span>
      </span>
        <!-- :row-selection="{ onSelect: selectTable, onSelectAll: selectAll }" -->
        <span slot="man_status_desc_second" slot-scope="text, record, index" style="color:red" v-html="record.man_status_desc_second">
        </span>
         <span slot="configure_type_desc" slot-scope="text, record">
          <a-popover title="元素标签" v-if="record.configure_type_desc">
              <template slot="content">
                <div v-html="record.configure_type_desc">
                </div>
              </template>
              <a type="primary">
                查看元素
              </a>
            </a-popover>
        </span>
        <span slot="priority" slot-scope="text, record">
          <span
            :style="{
              color:
                record.priority == '低'
                  ? '#00c300'
                  : record.priority == '中'
                  ? '#eba11b'
                  : 'red',
            }"
            >{{ record.priority }}</span
          >
        </span>
        <span slot="id" slot-scope="text, record, index">
          {{ pagination.pageSize * (pagination.current - 1) + index + 1 }}
        </span>
        <span slot="created_at" slot-scope="text, record, index">
          <span v-if="$store.state.user.is_specialist">{{
            record.created_at.split(" ")[0]
          }}</span>
          <span v-else>{{ record.created_at }}</span>
        </span>
        <span slot="status" slot-scope="text, record">
          <!-- <span v-if="record.discussion_status">已合议</span> -->
          <a
            v-if="
              evaluating ? record.deal_status == '待建议' : !record.is_finish
            "
            style="color: #f59a23"
            >待处理</a
          >
          <a v-else style="color: green">已处理</a>
        </span>
        <span slot="handle" slot-scope="text, record">
          <a
            v-if="
              evaluating ? record.deal_status == '待建议' : !record.is_finish
            "
            @click="goAudit(record)"
            >{{ evaluating ? "评测" : "审核" }}</a
          >
          <!-- <a v-else-if="record.discussion_status" @click="goAudit(record)">合议</a> -->
          <a v-else @click="goAudit(record, 'examine')">查看</a>
        </span>
        <span
          v-if="!record.is_second && record.man_status_desc"
          slot="man_status_desc"
          style="color: red"
          slot-scope="text, record"
          v-html="record.man_status_desc"
        >
        </span>
        <span
          v-else-if="record.is_second && record.man_status_desc_second"
          slot="man_status_desc"
          style="color: red"
          slot-scope="text, record"
          v-html="record.man_status_desc_second"
        >
        </span>
      </a-table>
    </a-card>
  </div>
  <AuditModule @setIsAudit="getIsAudit" :auditData="auditData" v-else />
</template>

<script>
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
import { specialist_check, age_specialist_task_list } from "@/api/association";
import AuditModule from "./audit/index.vue"; //注册审核组件
const plainOptions = ["待处理", "已处理"];
const options = [
  { label: "待处理", value: "待处理" },
  { label: "已处理", value: "已处理" },
];



const data = [];

function datas() {
  for (let i = 0; i < 100; i++) {
    let obj = {
      id: i + 1,
      name: "作品名称" + i,
      user: "审核人员" + i,
      date: "2021-09-24",
      status: "1",
      result: "这是一条很长很长很长很长很长很长很长很长很长的审核结果",
      audit: "",
    };
    data.push(obj);
  }
}
// datas();

export default {
  components: { AuditModule },
  data() {
    return {
      evaluating:
        this.$store.state.user.specialist_premission.indexOf("6") != -1
          ? true
          : false,
      plainOptions,
      options,
      value1: "Apple",
      locale,
      moment,
      ids: [],
      currentPageData: [],
      tableH: "", //表格容器高度
      columns:[], //表格抬头
      data, //表格数据
      works_name: "", //作品名称
      pagination: {
        //表格分页
        current: 1,
        total: 0,
        pageSize: 20, //每页中显示10条数据
        showSizeChanger: true,
        showLessItems: true,
        // hideOnSinglePage: true,
        pageSizeOptions: ["10", "20", "50", "100"], //每页中显示的数据
        showTotal: (total) => `共有 ${total} 条数据`, //分页中显示总的数据
        onChange: (page, pageSize) => {
          (this.pagination.current = page),
            (this.pagination.pageSize = pageSize);
          this.getData(this.status);
        },
        onShowSizeChange: (page, pageSize) => {
          (this.pagination.current = page),
            (this.pagination.pageSize = pageSize);
          this.getData(this.status);
        },
      },
      logModal: false,
      start: "",
      end: "",
      lens: "",

      /* 专家 */
      specialist: this.$store.state.user.specialist_premission,
      deal_status: 0, //评测状态
      isDeal: false, //是否是评测专家
      status:
        this.$store.state.user.specialist_premission.indexOf("6") != -1 ? 2 : 0,
      /* 审核子组件 */
      isAudit: true, //审核组件显示
      auditData: "", //审核组件需要的data数据
    };
  },
  created() {
    this.columns = [
  {
    title: "序号",
    dataIndex: "id",
    align: "center",
    scopedSlots: { customRender: "id" },
  },
  {
    title: "名称",
    dataIndex: "works_name",
    align: "center",
  },
  {
    title: "优先级",
    dataIndex: "priority",
    align: "center",
    scopedSlots: { customRender: "priority" },
    sorter: (a, b) => a.sort - b.sort,
  },
  {
    title: "审核机构情况",
    dataIndex: "man_status_desc_second",
    align: "center",
    scopedSlots: { customRender: "man_status_desc_second" },
  },
  {
    title: "审核次数",
    dataIndex: "is_second",
    align: "center",
    scopedSlots: { customRender: "is_second" },
  },
  {
    title: "元素",
    dataIndex: "configure_type_desc",
    align: "center",
    scopedSlots: { customRender: "configure_type_desc" },
  },
  {
    title: "操作",
    key: "handle",
    align: "center",
    scopedSlots: { customRender: "handle" },
  },
];
    if(this.evaluating){
      this.columns.map((item,index)=>{
        if(item.title == "优先级"){
          this.columns.splice(index,1)
          return
        }
      })
      this.columns.map((item,index)=>{
        if(item.title == "审核机构情况"){
          this.columns.splice(index,1)
          return
        }
      })
      this.tabChange(2)
    }else{
      this.columns.map((item,index)=>{
        if(item.title == "元素"){
          this.columns.splice(index,1)
          return
        }
      })
      
      this.tabChange(0)
    }
    this.getData();
    if (this.$store.state.user.is_specialist) {
      this.columns.map((item, index) => {
        if (item.title == "审核人员") {
          this.columns.splice(index, 1);
        } else if (item.title == "协会复审") {
          this.columns.splice(index, 1);
        }
      });
    }
  },
  mounted() {
    //表格高度自适应
    this.$nextTick(function () {
      this.tableH = document.body.clientHeight - 250; //259
      // tableDom.style.height= this.tableH+"px" //表格滚动条预留
    });
    //窗口改变自适应
    window.onresize = () => {
      return (() => {
        this.tableH = window.innerHeight - 250; //259
        // tableDom.style.height= this.tableH+"px" //表格滚动条预留
      })();
    };
  },
  methods: {
    //审核组件返回的按钮
    getIsAudit(val, reload, paramsVal) {
      this.isAudit = val;
      if (reload) {
        this.getData();
      }
      if (paramsVal) {
        this.status = paramsVal.status;
      }
    },
    //重置按钮
    resetBtn() {
      this.start = "";
      this.end = "";
      this.works_name = "";
    },
    //获取任务列表
    getData() {
      this.$store.commit("spinning", true);
      console.log(
        "this.$store.state.user.is_specialist &&this.evaluating",
        this.$store.state.user.is_specialist,
        this.evaluating
      );
      if (this.$store.state.user.is_specialist && this.evaluating) {
        //判断为评测专家
        this.isDeal = true;
        let data = `page_size=${this.pagination.pageSize}&page_no=${this.pagination.current}&works_name_like=${this.works_name}&deal_status=${this.status}`;
        age_specialist_task_list(data).then((res) => {
          console.log("任务列表", res.data);
          if (res.data.list) {
            this.data = res.data.list;
            /* this.lens = {
              total: res.data.total,
              finish: res.data.finish,
              no_finish: res.data.no_finish,
              discussion: res.data.discussion,
            }; */
            this.lens = res.data.status_count;
            this.pagination.total = res.data.total;
            // }
            
            this.$store.commit("spinning", false);
          } else {
            this.data = [];
            this.pagination.total = 0;
            this.$store.commit("spinning", false);
          }
        });
      } else {
        this.isDeal = false;
        //判断为内容审核专家
        specialist_check({
          // id:this.$store.state.user.id,
          page_size: this.pagination.pageSize,
          page_no: this.pagination.current,
          works_name: this.works_name,
          status:
            /* this.status== "0" ? "" : */ this.status /* == "1" ? "2" : "1" */,
          user_id: this.$store.state.user.id,
          ids: this.evaluating ? "6" : "",
          // start:this.start,
          // end:this.end,
        }).then((res) => {
          console.log("任务列表", res.data);
          if (res.data.list) {
            this.data = res.data.list;
            this.lens = {
              total: res.data.total,
              finish: res.data.finish,
              no_finish: res.data.no_finish,
              discussion: res.data.discussion,
            };
            this.pagination.total = res.data.total;
            // }
            
            this.$store.commit("spinning", false);
          } else {
            this.data = [];
            this.pagination.total = 0;
            this.$store.commit("spinning", false);
          }
        });
      }
    },

    //切换tab的动作
    tabChange(id) {
      this.status = id;
      if (this.evaluating) {
        if (id == 1) {
          let col = {
            title: "适龄标签",
            dataIndex: "age_label",
            align: "center",
          };
          let col1 = {
            title: "处理时间",
            dataIndex: "deal_time",
            align: "center",
          };
          let col2 = {
            title: "备注",
            dataIndex: "remark",
            align: "center",
          };
          let flag = false
          this.columns.map(item=>{
            if(item.title == "适龄标签"){
              flag = true
              return
            }
          })
          if(!flag){
            this.columns.splice(this.columns.length - 1, 0, col);
            this.columns.splice(this.columns.length - 1, 0, col1);
            this.columns.splice(this.columns.length - 1, 0, col2);
          }
        } else {
          this.columns.map(item=>{
            if(item.title == "适龄标签"){
              this.columns.splice(this.columns.length - 2, 1);
              this.columns.splice(this.columns.length - 2, 1);
              this.columns.splice(this.columns.length - 2, 1);
              return
            }
          })
        }
      }else{
        /* if (id == 0) {
          
          let flag = false
          this.columns.map(item=>{
            if(item.title == "已分配时间"){
              flag = true
              return
            }
          })
          if(!flag){
            this.columns.splice(this.columns.length - 1, 0, col);
          }
        }else{
          this.columns.map(item=>{
            if(item.title == "已分配时间"){
              this.columns.splice(this.columns.length - 2, 1);
              return
            }
          })
        } */
        // if (id == 2) {
        //   let col = {
        //     title: "审核机构情况",
        //     dataIndex: "man_status_desc_second",
        //     align: "center",
        //     scopedSlots: { customRender: "man_status_desc_second" },
        //   }
        //   /* let col1 = {
        //     title: "已分配时间",
        //     dataIndex: "date",
        //     align: "center",
        //   } */
        //   let flag = false
        //   this.columns.map(item=>{
        //     if(item.title == "审核机构情况"){
        //       flag = true
        //       return
        //     }
        //   })
        //   if(!flag){
        //     this.columns.splice(this.columns.length - 1, 0, col);
        //     // this.columns.splice(this.columns.length - 1, 0, col1);
        //   }
        // }else{
        //   this.columns.map(item=>{
        //     if(item.title == "审核机构情况"){
        //       this.columns.splice(this.columns.length - 2, 1);
        //       // this.columns.splice(this.columns.length - 2, 1);
        //       return
        //     }
        //   })
        // }
      }
      this.pagination.current = 1;
      this.getData();
    },
    //时间选择器
    onStart(data, dateString) {
      console.log(dateString);
      this.start = dateString;
    },
    onEnd(data, dateString) {
      console.log(dateString);
      let y = parseInt(dateString.split("-")[0]);
      let yy = parseInt(this.start.split("-")[0]);
      let m = parseInt(dateString.split("-")[1]);
      let mm = parseInt(this.start.split("-")[1]);
      let d = parseInt(dateString.split("-")[2]);
      let dd = parseInt(this.start.split("-")[2]);
      if (y < yy) {
        this.$message.error({
          content: "结束日期不能小于开始日期，请重新选择",
          duration: 2,
        });
        this.end = "";
      } else if (m < mm) {
        this.$message.error({
          content: "结束日期不能小于开始日期，请重新选择",
          duration: 2,
        });
        this.end = "";
      } else if (d < dd) {
        this.$message.error({
          content: "结束日期不能小于开始日期，请重新选择",
          duration: 2,
        });
        this.end = "";
      } else {
        this.end = dateString;
      }
    },
    //跳转剧本详情
    goAudit(record, examine) {
      console.log("选择的id", record, examine);
      this.isAudit = false;
      if (this.evaluating) {
        this.auditData = {
          id: record.works_id,
          type: examine,
          task: "task",
          status: this.status,
          specialist: "specialist",
          is_second: record.is_second,
          is_finish: record.deal_status == "待建议" ? 0 : 1,
        }; /* ass代表协会传入组件 */
      } else {
        this.auditData = {
          id: record.script_id,
          type: examine,
          task: "task",
          status: this.status,
          specialist: "specialist",
          is_second: record.is_second,
          is_finish: record.is_finish,
        }; /* ass代表协会传入组件 */
      }
    },
  },
};
</script>

<style lang="less" scoped>
.ant-row,
.btns {
  height: 40px;
  line-height: 40px;
  .btns {
    display: flex;
    justify-content: space-between;
    .ant-btn {
      margin: auto 0;
    }
  }
}
/deep/ .ant-input-prefix{
  font-size: 24px;
}
/deep/ .ant-input{
  font-size: 24px;
  height: 50px;
}
/deep/ .ant-input-affix-wrapper .ant-input:not(:first-child){
  padding-left: 40px;
}

/deep/ .ant-btn{
  font-size: 24px;
  height: 48px;
}

/deep/ .ant-tabs-nav-scroll{
  font-size: 24px;
}

/deep/ .ant-table{
  font-size: 24px;
}

/deep/ .ant-pagination,/deep/ .ant-select{
  font-size: 24px;
}

/deep/ .ant-list-items{
  font-size: 24px;
}
  

</style>